import React, { useState } from "react";
import { mediaUrl } from "@/lib/api";
import type { Review } from "@/types";
import { useRouter } from "@/router/Router";

export function ReviewCard({ review, showProduct }: { review: Review; showProduct?: boolean }) {
  const { navigate } = useRouter();
  const [zoom, setZoom] = useState<string | null>(null);
  return (
    <div className="card review-card">
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
        <strong style={{ fontSize: 14 }}>{review.authorName}</strong>
        <span className="review-card__stars" aria-label={`${review.rating}/5`}>
          {"★".repeat(review.rating)}
          <span style={{ opacity: 0.25 }}>{"★".repeat(5 - review.rating)}</span>
        </span>
      </div>
      {showProduct && review.product && (
        <button className="link-button" style={{ fontSize: 12.5 }} onClick={() => navigate({ name: "product", slug: review.product!.slug })}>
          {review.product.name}
        </button>
      )}
      {review.text && <p className="review-card__text">{review.text}</p>}
      {!!review.photos?.length && (
        <div className="review-photos">
          {review.photos.map((p) => (
            <button key={p} onClick={() => setZoom(p)}>
              <img src={mediaUrl(p)} alt="" loading="lazy" />
            </button>
          ))}
        </div>
      )}
      {zoom && (
        <div className="lightbox" role="dialog" aria-modal="true" onClick={() => setZoom(null)}>
          <button className="lightbox__close" onClick={() => setZoom(null)} aria-label="✕">
            ✕
          </button>
          <img src={mediaUrl(zoom)} alt="" style={{ mixBlendMode: "normal" }} />
        </div>
      )}
    </div>
  );
}
